import type { WrapperFC } from '@george-labs.com/design-system';
import { Button } from '@george-labs.com/design-system';

import type { Props } from './DetailPageStripeRightButton';
import { DetailPageStripeRightButton } from './DetailPageStripeRightButton';

export const DetailPageStripeRightPlainButton: WrapperFC<Props> = (props) => {
    return <DetailPageStripeRightButton {...props} ButtonComponent={Button} />;
};

DetailPageStripeRightPlainButton.wrapsComponent = Button;
